export default "__VITE_ASSET__58d18f70__"